import { FormFieldsEdit, WellStratumFieldsEdit, WellStratumFieldsView } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'

export interface LithologySummaryProps {
  strata: Partial<WellStratumFieldsView>[] | Partial<FormFieldsEdit>[]
}

export type FractionTypes = 'major' | 'minor' | 'secondary' | 'trace' | 'some'

export interface FractionTypeCardProps {
  fractionType: FractionTypes
  isLoading: boolean
}

export interface FractionTypeCardViewProps extends FractionTypeCardProps {
  stratum: Partial<Omit<WellStratumFieldsView, 'stratumCalculated' | 'notes'>>
}

export interface FractionTypeCardEditProps extends FractionTypeCardProps {
  stratum: Partial<Omit<WellStratumFieldsEdit, 'stratumCalculated' | 'notes'>>
  setValue: SetValue<WellStratumFieldsEdit>
  validationErrors: ValidationErrors<WellStratumFieldsEdit>
  isNewRecord?: boolean
  isExistingOrDecommissioned?: boolean
}

export interface TabState {
  activeTab: number
  prevFormSaved: boolean
}

export enum FractionTypeKeys {
  MAJOR = 'major',
  SECONDARY = 'secondary',
  SOME = 'some',
  MINOR = 'minor',
  TRACE = 'trace',
}

// This list controls the vertical order of the FractionCards when rendering
export const fractionTypes: FractionTypes[] = Object.values(FractionTypeKeys)

export enum FractionTypeAllowableFields {
  CO = 'CO',
  RO = 'RO',
  SO = 'SO',
  WE = 'WE',
  GS = 'GS',
  ST = 'ST',
  PL = 'PL',
}

export enum FractionTypeDescriptors {
  COLOUR = 'Colour',
  GRAINSIZE = 'Grainsize',
  ROCKSTRENGTH = 'RockStrength',
  SORTING = 'Sorting',
  WEATHERING = 'Weathering',
  ROUNDING = 'Rounding',
  PLASTICITY = 'Plasticity',
  FRACTURING = 'Fracturing',
}

export const fractionDescriptors = [
  'Weathering',
  'Grainsize',
  'Plasticity',
  'Rounding',
  'Sorting',
  'RockStrength',
  'Fracturing',
]
